<template>
  <div
    class="common-header h-60 flex justify-between align-center padding-lr-30"
  >
    <div class="flex flex-sub">
      <div class="text-main">投稿</div>
      <div class="common-header__nav" style="margin-left: 10%">
        <div
          v-for="item in navItems"
          :key="item.value"
          :class="[
            'nav-item',
            { active: item.value === activeNav },
            { 'nav-item--hot': item.value === 'hotRank' },
          ]"
          @click="handleSelect(item)"
        >
          <span class="nav-item__label">{{ item.label }}</span>
          <span v-if="item.badge" class="nav-item__badge">{{
            item.badge
          }}</span>
        </div>
      </div>
    </div>
    <!-- 登录状态：显示头像和昵称 -->
    <div
      v-if="isLoggedIn"
      class="user-info-wrapper"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <div class="user-info flex align-center">
        <img :src="userAvatar" alt="avatar" class="user-avatar" />
        <span class="user-name">{{ userName }}</span>
        <i class="el-icon-arrow-down arrow-icon"></i>
      </div>
      <!-- 退出选项 -->
      <div
        v-show="showLogout"
        class="logout-dropdown"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <div class="logout-item" @click="handleLogout">退出登录</div>
      </div>
    </div>
    <!-- 未登录状态：显示登录按钮 -->
    <el-button
      v-else
      class="action-btn"
      size="small"
      type="primary"
      round
      @click="handleAction"
      >{{ actionText }}</el-button
    >
  </div>
</template>

<script>
import { getUserInfo } from "@/api/user";

export default {
  name: "CommonHeader",
  data() {
    return {
      actionText: "登录系统",
      activeNav: "home",
      showLogout: false,
      hideTimer: null,
      headerUserInfo: null, // 从接口拉取的头像、昵称，与个人中心一致
      navItems: [
        { label: "首页", value: "home" },
        { label: "一键投稿", value: "quick" },
        { label: "会员中心", value: "member" },
        { label: "通讯录", value: "addressBook" },
        { label: "关于我们", value: "about" },
        { label: "个人中心", value: "profile" },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      // 检查登录状态，可以从 localStorage 或 Vuex 获取
      return (
        localStorage.getItem("isLoggedIn") === "true" ||
        this.$store?.state?.user?.isLoggedIn
      );
    },
    userName() {
      // 优先使用接口拉取的用户信息（与个人中心一致）
      if (this.headerUserInfo && this.headerUserInfo.nickname) {
        return this.headerUserInfo.nickname;
      }
      const name = localStorage.getItem("userName");
      if (name && name !== "用户") {
        return name;
      }
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        try {
          const info = JSON.parse(userInfo);
          return (
            info.nickname ||
            (info.userinfo && info.userinfo.nickname) ||
            info.username ||
            "用户"
          );
        } catch (e) {
          return "用户";
        }
      }
      return this.$store?.state?.user?.name || "用户";
    },
    userAvatar() {
      // 优先使用接口拉取的头像（与个人中心一致）
      if (this.headerUserInfo && this.headerUserInfo.avatar) {
        return this.headerUserInfo.avatar;
      }
      const avatar = localStorage.getItem("userAvatar");
      if (avatar) {
        return avatar;
      }
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        try {
          const info = JSON.parse(userInfo);
          const av = info.avatar || (info.userinfo && info.userinfo.avatar);
          if (av) return av;
        } catch (e) {}
      }
      return require("@/assets/images/login.png");
    },
  },
  mounted() {
    this.updateActiveNav();
    if (this.$router) {
      this.$router.afterEach(() => {
        this.updateActiveNav();
      });
    }
    // 已登录时拉取用户信息，保证头像与个人中心一致
    if (
      localStorage.getItem("isLoggedIn") === "true" ||
      this.$store?.state?.user?.isLoggedIn
    ) {
      getUserInfo()
        .then((res) => {
          if (res.data) {
            this.headerUserInfo = {
              avatar:
                res.data.avatar ||
                (res.data.userinfo && res.data.userinfo.avatar),
              nickname:
                res.data.nickname ||
                (res.data.userinfo && res.data.userinfo.nickname) ||
                res.data.username ||
                "用户",
            };
            if (this.headerUserInfo.avatar) {
              localStorage.setItem("userAvatar", this.headerUserInfo.avatar);
            }
            if (this.headerUserInfo.nickname) {
              localStorage.setItem("userName", this.headerUserInfo.nickname);
            }
          }
        })
        .catch(() => {});
    }
  },
  beforeDestroy() {
    // 清除定时器
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  },
  methods: {
    handleMouseEnter() {
      // 清除隐藏定时器
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      // 显示下拉菜单
      this.showLogout = true;
    },
    handleMouseLeave() {
      // 延迟隐藏，给用户时间移动到下拉菜单
      this.hideTimer = setTimeout(() => {
        this.showLogout = false;
        this.hideTimer = null;
      }, 200);
    },
    updateActiveNav() {
      if (!this.$router) return;

      const currentPath = this.$router.currentRoute.path;
      const routeMap = {
        "/": "home",
        "/hot": "hotRank",
        "/quick-submit": "quick",
        "/status": "status",
        "/history": "history",
        "/member": "member",
        "/address-book": "addressBook",
        "/about": "about",
        "/profile": "profile",
      };

      // 根据当前路径设置 activeNav
      this.activeNav = routeMap[currentPath] || "home";
    },
    handleSelect(item) {
      this.activeNav = item.value;
      if (this.$router) {
        const routeMap = {
          home: "/",
          quick: "/quick-submit",
          status: "/status",
          history: "/history",
          member: "/member",
          addressBook: "/address-book",
          hotRank: "/hot",
          about: "/about",
          profile: "/profile",
        };
        const target = routeMap[item.value];
        if (target && this.$router.currentRoute.path !== target) {
          this.$router.push(target);
        }
      }
    },
    handleAction() {
      this.$router ? this.$router.push("/login") : window.location.reload();
    },
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 清除登录状态和用户信息（必须包含 token，否则个人中心等接口仍会用旧用户 token）
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("userName");
          localStorage.removeItem("userAvatar");
          localStorage.removeItem("userId");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("token");
          if (this.$store) {
            this.$store.commit("user/logout");
          }
          this.$message.success("已退出登录");
          this.showLogout = false;
          // 跳转到登录页
          if (this.$router) {
            this.$router.push("/login");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.common-header {
  width: 100%;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.common-header__nav {
  background: #fff;
  border-radius: 12px 12px 0 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.common-header__nav nav {
  display: flex;
  align-items: center;
  height: 52px;
}

.nav-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-right: 78px;
  color: #000;
  cursor: pointer;
  transition: color 0.2s;
}

.nav-item:last-child {
  margin-right: 0;
}

.nav-item__label {
  display: inline-block;
}

/* 热榜：品牌色 + NEW 角标（右上角） */

.nav-item--hot:hover {
  color: #d63d68;
}

.nav-item--hot.active {
  color: #e85078;
}

.nav-item--hot .nav-item__badge {
  position: absolute;
  top: -8px;
  right: -22px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  padding: 2px 5px;
  color: #fff;
  background: linear-gradient(135deg, #ff6b6b, #e85078);
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(232, 80, 120, 0.45);
  pointer-events: none;
}

.nav-item.active:not(.nav-item--hot) {
  color: #ec407a;
  font-weight: 600;
}

.nav-item:hover:not(.nav-item--hot) {
  color: #ec407a;
}

.action-btn {
  width: 102px;
  height: 34px;
  background: #d85a70;
  border-radius: 7px 7px 7px 7px;
  border: none;
}

/* 用户信息区域 */
.user-info-wrapper {
  position: relative;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  border-radius: 20px;
  transition: all 0.3s;
}

.user-info:hover {
  background: #f5f5f5;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #f0f0f0;
}

.user-name {
  font-size: 14px;
  color: #212121;
  font-weight: 500;
}

.arrow-icon {
  font-size: 12px;
  color: #999;
  transition: transform 0.3s;
}

.user-info-wrapper:hover .arrow-icon {
  transform: rotate(180deg);
}

/* 退出下拉菜单 */
.logout-dropdown {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  z-index: 1000;
  overflow: hidden;
}

.logout-item {
  padding: 12px 20px;
  font-size: 14px;
  color: #212121;
  cursor: pointer;
  transition: all 0.3s;
}

.logout-item:hover {
  background: #f5f5f5;
  color: #d85a70;
}
</style>
